export const insideFlowNodes = (
  buttonId,
  existingFlowId,
  handleNodeChange,
  onNodesDelete,
  handleOutputClick,
  handleEdgeDelete
) => {
  const buttonNode = {
    id: buttonId,
    type: 'button',
    position: {
      x: 73,
      y: 218,
    },
    data: {
      id: buttonId,
      type: 'button',
      header: '',
      body: 'please type your message',
      footer: '',
      text: '',
      sourceType: '',
      buttons: ['Main menu'],
      media: {},
      nodeCount: '1',
      params: {
        global: [],
        result: [],
        webform: [],
        entity: [],
        lead_data: [],
        global_lead_data: [],
      },
      parentResults: [],
      onChange: handleNodeChange,
      onNodesDelete,
      onOutputClick: handleOutputClick,
    },
  };

  const existingFlowNode = {
    id: existingFlowId,
    type: 'existingFlow',
    position: {
      x: 540,
      y: 423,
    },
    data: {
      id: existingFlowId,
      type: 'existingFlow',
      header: '',
      body: '',
      footer: '',
      text: '',
      sourceType: '',
      media: {},
      nodeCount: '2',
      parentResults: [],
      // selectedFlow: {
      //   _id: '6a02c7c784c2a92a1697d41a',
      //   title: 'Hiring bot',
      // },
      onChange: handleNodeChange,
      onNodesDelete,
      onOutputClick: handleOutputClick,
    },
  };

  const edge = {
    id: `${buttonId}-${existingFlowId}`,
    source: buttonId,
    sourceHandle: `${buttonId}-button-0`,
    target: existingFlowId,
    targetHandle: null,
    type: 'custom',
    style: {
      strokeWidth: 3,
    },
    markerEnd: {
      type: 'arrowclosed',
    },
    data: {
      onDelete: handleEdgeDelete,
    },
  };

  return {
    nodes: [buttonNode, existingFlowNode],
    edges: [edge],
  };
};